import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toaster } from 'sonner';

import { router } from './routes/router';
import { queryClient } from './lib/query-client';
import { useUIStore } from './lib/store';
import { applyUiScale } from './lib/ui-scale';
import { TooltipProvider } from './components/ui/Tooltip';
import { AuthProvider } from './features/auth/AuthContext';

// i18n-init alustaa kielen ennen ensimmaista renderia ja kytkee storeen
import './lib/i18n';

import './styles/globals.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root puuttuu index.html:stä');
}

// UI-skaalaus (Sessio 21.5): sovella tallennettu taso juureen ENNEN ensimmaista
// maalausta jotta korkeampi skaala ei valahda 100 %:sta. useUIStore:n persist-middleware
// hydratoi localStoragen synkronisesti, joten getState() palauttaa tallennetun arvon heti.
applyUiScale(useUIStore.getState().uiScale);

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <TooltipProvider delayDuration={300}>
          <RouterProvider router={router} />
          <Toaster
            position="bottom-right"
            richColors
            closeButton
            // PAR-H0 (Joanna 12.–13.8.2026, kaksi viestiä): virheilmoitukset ehtivät kadota
            // ennen kuin ne on luettu. Sonner ei tue tyyppikohtaista kestoa (vain globaali),
            // joten nostetaan kaikkien kestoa 4 s -> 8 s; closeButton sallii sulkea heti.
            duration={8000}
            toastOptions={{
              classNames: {
                toast: 'rounded-sm border border-kaste shadow-card-hover',
              },
            }}
          />
          {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
        </TooltipProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
